import { render, staticRenderFns } from "./skill-inactive.component.html?vue&type=template&id=612a2850&scoped=true&external"
import script from "./skill-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./skill-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./skill-inactive.component.scss?vue&type=style&index=0&id=612a2850&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a2850",
  null
  
)

export default component.exports